import { Injectable } from '@angular/core';
import { API } from '@aws-amplify/api';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import {
  QAPostNotificationFail,
  QAPostNotificationSuccess,
  RtpSendFailed,
  RtpSendSuccess
} from 'src/app/features/qa-testing/redux/qa.actions';
import { QAInsightEvent } from 'src/app/models/qa-models/qa-models';
import { RealTimePersonalizationEvent } from 'src/app/models/rtp-models';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class QaServiceService {
  public submittedNotification;
  public timelineNotifications: any;
  public sentEstimates;
  public timeline_notifications_api = APIS.TIMELINE_NOTIFICATIONS;
  public notifications_api = APIS.NOTIFICATIONS;
  public cleaning_estimates_api = APIS.CLEANING_ESTIMATES;
  public rtp_api = APIS.RTP;

  constructor(
    private toastrService: NbToastrService,
    private store: Store
  ) {}

  public loadTimelineNotificationsAmplify(selectedRobot) {
    API.get(
      this.timeline_notifications_api,
      `/circuit/robot/${selectedRobot.id || selectedRobot.robotid}/timeline/hkc`,
      {}
    )
      .then((response) => {
        this.timelineNotifications = response;
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, 'Load Timeline Notifications: Fail', {
          status: 'danger'
        });
      });
  }

  public submitNotification(notification: QAInsightEvent): void {
    API.post(this.notifications_api, `/${ENVIRONMENT.name}/campaigns/qa/notifications`, { body: notification })
      .then((response) => {
        this.submittedNotification = response;
        this.store.dispatch(new QAPostNotificationSuccess());
      })
      .catch((error) => {
        this.store.dispatch(new QAPostNotificationFail(error));
      });
  }

  public submitRTPNotification(event: RealTimePersonalizationEvent): void {
    API.put(this.rtp_api, `/${ENVIRONMENT.name}/campaigns/qa/rtp`, { body: event })
      .then((response) => {
        this.store.dispatch(new RtpSendSuccess());
      })
      .catch((error) => {
        this.store.dispatch(new RtpSendFailed());
      });
  }

  public submitCleaningEstimateAmplify(estimate) {
    API.post(this.cleaning_estimates_api, `/${ENVIRONMENT.name}/insights/qa/cleaning-estimates`, { body: estimate })
      .then((response) => {
        this.sentEstimates = estimate;
      })
      .catch((error) => {
        console.error('Error occured', error);
      });
  }

  public submitRobotHealthAmplify(robot_id: string, campaign_id: string, counters: any[]) {
    API.post(this.notifications_api, `/${ENVIRONMENT.name}/campaigns/qa/robot-health`, {
      body: {
        robot_id,
        campaign_id,
        robot_health_notification: {
          counters
        }
      }
    })
      .then((response) => {
        this.store.dispatch(new QAPostNotificationSuccess());
      })
      .catch((error) => {
        this.store.dispatch(new QAPostNotificationFail(error));
        console.error('Error occured', error);
      });
  }
}
